export default __webpack_public_path__ + "static/media/type3.a6bce7cd.png";